<template>
  <section class="upcoming-workshop workshop-list">
    <div class="container workshop_list">
      <div class="row">
        <div

          class="workshop-item cardover"
          v-for="WSData in WorkshopData"
          :key="WSData.id"
        >
         <router-link
            :to="{
              name: 'workshop',
              params: { workshopId: WSData.id },
            }"

            >
          <div class="workshop__author-pic">
            <u-live-icon v-if="WSData.category.includes('live')"></u-live-icon>
            <img :src="`https://backend.upskill.com.bd${WSData.image}`" />
          </div>
          <div class="workshop__info">
            <!--            <p class="workshop__info-date">{{ getTime(WSData.workshop_ts) }}</p>-->
            <h3 class="workshop__info-title">{{ WSData.name }}</h3>

            <p class="workshop__info-speaker">
              -
            </p>
          </div>

          <div class="workshop__action">
            <div class="workshop__action-info">
              <span v-if="WSData.hasDiscount == undefined">{{
                WSData.fee === 0 ? "Free" : `৳.${WSData.fee}`
              }}</span>
              <span v-else
                ><strike>{{ WSData.fee }}</strike> Tk.{{
                  getDiscount(WSData.discountedPrice)
                }}</span
              >
              <span>{{ getTime(WSData.workshop_ts) }}</span>
            </div>
            <div class="workshop__action-register ">
              <router-link
                :to="{
                  name: 'workshop',
                  params: { workshopId: WSData.id }
                }"
                class="btn btn-success"
                >View Workshop</router-link
              >
              <!-- <a href="#" class="btn btn-success"></a> -->
            </div>
          </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import {WorkshopData} from '../../api';

var moment = require("moment");
export default {
  name: "workshop",
  props: ["WorkshopData"],
  data() {
    return {
      hasDiscount: false,
      discountedPrice: 0,
      discountedWs: {}
    };
  },
  methods: {
    getTime(wstime) {
      // console.log(wstime)
      if (moment(wstime).unix() - moment().unix() > 0) {
        return (moment(wstime).fromNow() + " left").replace("in", "");
      } else {
        return moment(wstime).fromNow();
      }
    }
  }
};
</script>
